
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkUser } from '../models/work-user';

export function getPasswordResetTokenFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    token: new FormControl<string | undefined>('', [Validators.required]),
    expires: new FormControl<string | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    user: new FormControl<WorkUser | undefined>(undefined),
})
;
}
      